export default __webpack_public_path__ + "static/media/lock.c52dc52f.svg";